import { put } from "../../Services/http";
import { catchError } from "../../Actions/Error.action";
import { load as loadCart } from "../../Actions/Cart.action";

export const SERVICE_ORDERS_ROW_QUANTITY_UPDATED =
  "SERVICE_ORDERS_ROW_QUANTITY_UPDATED";
export const SERVICE_ORDERS_RECEIVE = "SERVICE_ORDERS_RECEIVE";
export const SERVICE_ORDERS_SET_LOADING = "SERVICE_ORDER_SET_LOADING";
export const SERVICE_ORDERS_IS_PROCESSING = "SERVICE_ORDERS_IS_PROCESSING";
export const SERVICE_ORDERS_ERROR = "SERVICE_ORDER_ERROR";
export const SERVICE_ORDERS_CLEAR_ERROR = "SERVICE_ORDERS_CLEAR_ERROR";

export const CHECKOUT_SET_ORDER_NOTES = "CHECKOUT_SET_ORDER_NOTES";

export const setExtraFields = (extraFields) => ({
    type: CHECKOUT_SET_ORDER_NOTES,
    payload: {
        extraFields,
    }
});

export const clearError = () => {
  return {
    type: SERVICE_ORDERS_CLEAR_ERROR,
    payload: {},
  }
};

export const setLoading = (orderId) => ({
  type: SERVICE_ORDERS_SET_LOADING,
  payload: {
    orderId: orderId,
    isLoading: true,
  },
});

export const isProcessing = (isProcessing) => ({
  type: SERVICE_ORDERS_IS_PROCESSING,
  payload: {
    isProcessing: isProcessing,
  },
});

export const clearState =
  (serviceOrderId) => (dispatch, getState) => {
    dispatch(clearError());
    dispatch(loadCart())
      .then(() => dispatch(scrollToOrder(serviceOrderId)));
  };

export const addCartItemsToServiceOrder =
  (serviceOrderId) => (dispatch, getState) => {
    dispatch(isProcessing(true));
    const cart = getState().cart;
    const cartItems = cart.orderRows;

    const serviceOrder = getState().serviceOrders.items.find(
      (order) => order.id === serviceOrderId
    );
    const orderUpdateModelItems = serviceOrder.orderRows.map((orderRow) => ({
      productId: orderRow.articleNumber,
      quantity: orderRow.quantity,
      isAddOn: orderRow.isAddOn,
      isBigPack: orderRow.isBigPack
    }));

    cartItems.forEach((cartItem) => {
      const orderItem = orderUpdateModelItems.find(
        (item) => item.productId === cartItem.articleNumber && item.isBigPack === cartItem.isBigPack
      );
      if (orderItem) {
        orderItem.quantity =
          (Number.isInteger(parseInt(orderItem.quantity))
            ? orderItem.quantity
            : 0) + cartItem.quantity;
        orderItem.isAddOn = orderItem.isAddOn || cartItem.isAddOn;
      } else {
        orderUpdateModelItems.push({
          productId: cartItem.articleNumber,
          quantity: cartItem.quantity,
          isAddOn: cartItem.isAddOn,
          isBigPack: cartItem.isBigPack
        });
      }
    });

    const cartMergedOrderRowIds = cartItems.map((row) => row.rowSystemId);
    const updateModel = {
      serviceOrderId: serviceOrder.id,
      salesOrderId: serviceOrder.salesOrderId,
      items: orderUpdateModelItems,
      mergedCartRowSystemIds: cartMergedOrderRowIds,
    };

    dispatch(updateServiceOrder(updateModel));
  };

export const saveServiceOrder = (orderId) => async (dispatch, getState) => {
  var serviceOrder = getState().serviceOrders.items.find(
    (order) => order.id === orderId
  );

  const orderItems = serviceOrder.orderRows
    .filter((orderRow) => orderRow.quantity > 0)
    .map((orderRow) => ({
      productId: orderRow.articleNumber,
      quantity: orderRow.quantity,
      isAddOn: orderRow.isAddOn,
      isBigPack: orderRow.isBigPack  
    }));

  const updateModel = {
    serviceOrderId: serviceOrder.id,
    salesOrderId: serviceOrder.salesOrderId,
    items: orderItems,
    mergedCartRowSystemIds: [],
  };

  dispatch(updateServiceOrder(updateModel));
};

export const updateServiceOrder =
  (updateModel) => async (dispatch, getState) => {
    dispatch(setLoading(updateModel.serviceOrderId));

    await setTimeout(
      () =>
        put(`/api/serviceorder`, updateModel)
          .then((response) => response.json())
          .then((serviceOrder) => dispatch(receive(serviceOrder)))
          .catch((ex) => dispatch(catchError(ex, (error) => loadError(updateModel.serviceOrderId, error))))
          .finally(() => dispatch(isProcessing(false))),
      0
    );
  };

export const loadError = (serviceOrderId, error) => {
  console.log("Error on Service order");
  console.log({ error });

  return {
    type: SERVICE_ORDERS_ERROR,
    payload: {
      id: serviceOrderId,
      error: error
    }
  }
};

export const receive = (serviceOrders) => ({
  type: SERVICE_ORDERS_RECEIVE,
  payload: serviceOrders,
});

export const setRowQuantity = (serviceOrderId, orderRowId, quantity) => ({
  type: SERVICE_ORDERS_ROW_QUANTITY_UPDATED,
  payload: {
    serviceOrderId,
    orderRowId,
    quantity,
  },
});

export const scrollPageToOrder =
  (serviceOrderId) => {
    const scrollTo = document.getElementById('serviceOrder' + (serviceOrderId));
    if (scrollTo) {
      const header = document.getElementsByTagName('header');
      const headerHeight = header[0].offsetHeight;
      const scrollCount = scrollTo.offsetTop - headerHeight - 5;
      window.scroll({
        top: scrollCount,
        behavior: 'smooth',
      });
    }
  };

const scrollToOrder =
  (serviceOrderId) => (dispatch, getState) => {
    scrollPageToOrder(serviceOrderId);
  };

